"use client"

import { usePagination } from "react-instantsearch"

import { clx } from "@modules/common/components/ui"

const SearchPagination = () => {
  const { pages, currentRefinement, nbPages, refine } = usePagination({
    padding: 2,
  })

  if (nbPages <= 1) {
    return null
  }

  const renderPage = (page: number) => (
    <button
      key={page}
      className={clx("w-9 h-9 border border-zl-line bg-white font-mono text-xs tabular-nums text-zl-steel hover:border-zl-ink hover:text-zl-ink", {
        "!bg-zl-ink !border-zl-ink !text-zl-canvas": page === currentRefinement,
      })}
      disabled={page === currentRefinement}
      onClick={() => refine(page)}
    >
      {page + 1}
    </button>
  )

  const renderEllipsis = (key: string) => (
    <span
      key={key}
      className="w-9 h-9 flex items-center justify-center font-mono text-xs text-zl-mute cursor-default"
    >
      ...
    </span>
  )

  const lastPage = nbPages - 1

  return (
    <div className="flex justify-center w-full mt-12">
      <div className="flex gap-1 items-center" data-testid="product-pagination">
        {!pages.includes(0) && renderPage(0)}
        {!pages.includes(0) && !pages.includes(1) && renderEllipsis("start")}
        {pages.map(renderPage)}
        {!pages.includes(lastPage) &&
          !pages.includes(lastPage - 1) &&
          renderEllipsis("end")}
        {!pages.includes(lastPage) && renderPage(lastPage)}
      </div>
    </div>
  )
}

export default SearchPagination
